module.exports = __webpack_public_path__ + "assets/img/01.ead33c64.png";